import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import HeaderThin from 'app/components/layout/HeaderThin';
import ProgressIndicator, { IStep } from 'app/components/general/ProgressIndicator';

// Actions
import * as groupsActions from 'app/ducks/groups/actions';
import * as organisationsActions from 'app/ducks/organisations/actions';
import * as organisationSectionActions from 'app/ducks/organisationSections/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as connectActions from 'app/ducks/connect/actions';
import * as teamConnectionActions from 'app/ducks/teamConnections/actions';
import * as competitionActions from 'app/ducks/competitions/actions';
import * as dashboardActions from 'app/ducks/dashboard/actions';

// Selectors
import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as organisationSectionSelectors from 'app/ducks/organisationSections/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import ConfirmTeam from './components/ConfirmTeam';
import SelectTeam from './components/SelectTeam';

interface IConnectTeamLayoutProps {
  match: any;
  organisations: any;
  organisationSections: any;
  teams: any;
  connect: any;
  groups: any;
  actions: any;
  appReady: boolean;
}

function selector(state): any {
  return {
    organisations: organisationSelectors.getOrganisations(state),
    user: state.users,
    connect: state.connect,
    teams: teamsSelectors.getTeams(state),
    groups: groupsSelectors.getGroups(state),
    organisationSections: organisationSectionSelectors.getOrganisationSections(
      state,
    ),
    competitions: competitionSelectors.getCompetitions(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  groupsActions,
  organisationsActions,
  organisationSectionActions,
  teamsActions,
  teamConnectionActions,
  connectActions,
  competitionActions,
  dashboardActions,
);

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class ConnectTeamLayout extends React.Component<
IConnectTeamLayoutProps,
{}
> {
  static defaultProps = {
    match: undefined,
    organisations: undefined,
    competitions: undefined,
    organisationSections: undefined,
    groups: undefined,
    teams: undefined,
    actions: undefined,
    appReady: false,
    connect: undefined,
  };

  readonly state: any = {
    connect: {},
  };

  render(): React.ReactNode {
    const steps: IStep[] = [
      {
        number: 1,
        text: 'Select Team',
        complete: this.props.match.path === '/connect-team/confirm',
        active: this.props.match.path === '/connect-team',
      },
      {
        number: 2,
        text: 'Confirm & Connect Team',
        complete: false,
        active: this.props.match.path === '/connect-team/confirm',
      },
    ];
    return (
      <RenderContent className="people-app" match={this.props.match}>
        <div>
          <div className="row">
            <div className="col">
              <HeaderThin title="Connect Team" divider />
            </div>
          </div>
          <div className="row">
            <div className="col col-md-8 col-lg-6">
              <ProgressIndicator steps={steps} />
            </div>
          </div>
          <Route
            exact
            path="/connect-team"
            render={(): React.ReactNode => (
              <SelectTeam
                currentTeam={this.props.teams.currentTeam}
                organisations={this.props.organisations}
                competitions={this.props.competitions}
                organisationSections={this.props.organisationSections}
                handleConnect={this.props.actions.updateConnect}
                groups={this.props.groups}
                teams={this.props.teams}
                actions={this.props.actions}
                appReady={this.props.appReady}
              />
            )}
          />
          <Route
            exact
            path="/connect-team/confirm"
            render={(): React.ReactNode => (
              <ConfirmTeam
                connect={this.props.connect}
                actions={this.props.actions}
                teamId={this.props.teams.currentTeamId}
                appReady={this.props.appReady}
              />
            )}
          />
        </div>
      </RenderContent>
    );
  }
}
